import type { Query, QueryClient } from '@tanstack/react-query';
import { usePrivacyStore } from '@/store/privacyStore';
import { QUERY_KEYS } from '@/utils/constants';

/**
 * 서버가 개인정보를 가려 보내는 캐시의 첫 키. 백엔드에서 `@MaskPii()` 가 붙은
 * 컨트롤러(기관·사용자·관리자 민원·포털 민원)와 짝이 맞아야 한다.
 */
const PII_QUERY_ROOTS = new Set<unknown>([
  'institutions',
  'institution',
  QUERY_KEYS.USERS,
  'complaints',
]);

const holdsPii = (query: Query): boolean => {
  const [first, second] = query.queryKey;
  return PII_QUERY_ROOTS.has(first) || (first === 'portal' && second === 'complaints');
};

/**
 * 해제·재가림 순간에 개인정보가 담긴 캐시를 다시 받는다.
 *
 * 해제하면 원본을 받아 와야 화면에 보이고, 다시 가리면 메모리에 남은 원본을
 * 가린 값으로 바꿔야 한다. 보고 있지 않은 화면의 캐시는 아예 지운다 — 원본을
 * 들고 있을 이유가 없다.
 */
export function syncPrivacyCache(queryClient: QueryClient): () => void {
  return usePrivacyStore.subscribe((state, prev) => {
    if (state.revealToken === prev.revealToken) return;
    queryClient.removeQueries({ predicate: holdsPii, type: 'inactive' });
    void queryClient.invalidateQueries({ predicate: holdsPii });
  });
}
